module.exports = __webpack_public_path__ + "img/26@2x.ef6e5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/26@2x.png
// module id = lbgI
// module chunks = 0